import {
  WSCard,
  WSFlexBox,
  WSInfoBox,
  WSText,
  WSTooltipIcon
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { selectorAccountBalance } from "../../../shared/selectors/selectorAccountBalance";
import { useModalBalanceInfo } from "../modals/useModalBalanceInfo";
import { queriesInternalAccounts } from "@query";

type Props = {
  internalAccountId: string;
};

export const InternalAccountBalance: React.FC<Props> = props => {
  const history = useHistory();
  const queryInternalAccount =
    queriesInternalAccounts.getInternalAccount.useQuery({
      internalAccountId: props.internalAccountId
    });
  const queryInternalAccountBalance =
    queriesInternalAccounts.getInternalAccountBalance.useQuery({
      internalAccountId: props.internalAccountId
    });
  const modalBalanceInfo = useModalBalanceInfo();

  const balance = selectorAccountBalance(queryInternalAccountBalance.data);
  const availableBalance = balance.available;
  const currentBalance = balance.balance;
  const pendingAmounts = balance.hold;

  return (
    <WSCard
      shimmer={queryInternalAccountBalance.isInitialLoading}
      fullHeight
      header={{
        label: {
          text: "Available balance",
          tooltip: {
            customAction: () => modalBalanceInfo.open()
          }
        }
      }}
      divider
      actions={
        queryInternalAccount.data?.type === "ApPayouts"
          ? {
              alignment: "fill",
              buttons: [
                {
                  kind: "Secondary",
                  label: "Transfer",
                  onClick: () => {
                    history.push({
                      pathname: "/member/transfer",
                      search: "?balance=platform&type=withdrawal"
                    });
                  }
                }
              ]
            }
          : undefined
      }
    >
      <WSText.Heading1
        weight="book"
        color={availableBalance > 0 ? "gray600" : "gray200"}
        mb="XL"
      >
        {formatMoney(availableBalance, balance.currency)}
      </WSText.Heading1>

      <WSFlexBox.CenterY justify="space-between" mb="M">
        <WSFlexBox.CenterY>
          <WSText.ParagraphSm color="gray500">Total balance</WSText.ParagraphSm>
          <WSTooltipIcon
            customAction={() => modalBalanceInfo.open()}
            ml="XS"
            size="XS"
          />
        </WSFlexBox.CenterY>
        <WSText.ParagraphSm color="gray600">
          {formatMoney(currentBalance, balance.currency)}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>

      <WSFlexBox.CenterY justify="space-between">
        <WSFlexBox.CenterY>
          <WSText.ParagraphSm color="gray500">
            Pending amounts
          </WSText.ParagraphSm>
          <WSTooltipIcon
            customAction={() => modalBalanceInfo.open()}
            ml="XS"
            size="XS"
          />
        </WSFlexBox.CenterY>
        <WSText.ParagraphSm color="gray500">
          {formatMoney(pendingAmounts, balance.currency)}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>

      {queryInternalAccount.data?.type === "ApPayouts" && (
        <WSInfoBox mt="XL" title="Transferring your available balance">
          We recommend transferring the available balance to your external bank
          account regularly (within 90 days the balance became available). The
          Platform Balance is for temporarily holding balances from paid
          invoices to be transferred out and cannot accept deposits from
          external bank accounts.
        </WSInfoBox>
      )}
    </WSCard>
  );
};
